module.exports = __webpack_public_path__ + "assets/img/yutariya.1bedce4e.svg";